export class OrderPrice {
  basePrice: number;
  operatorShare?: number;
  percentageOfSale = 0;
}
